import { render, staticRenderFns } from "./SpecialPosition.vue?vue&type=template&id=b92b44d2&"
import script from "./SpecialPosition.vue?vue&type=script&lang=js&"
export * from "./SpecialPosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports